import { render } from "./Multiselect.vue?vue&type=template&id=6f58324e&scoped=true&ts=true"
import script from "./Multiselect.vue?vue&type=script&lang=ts"
export * from "./Multiselect.vue?vue&type=script&lang=ts"

import "./Multiselect.vue?vue&type=style&index=0&id=6f58324e&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f58324e"]])

export default __exports__